export const getDefaultPath = (defaultPid: number | null, defaultEid: number | null): string => {
    return defaultPid ? `/p/${defaultPid}/home` : defaultEid ? `/e/${defaultEid}/realtime` : 'login';
};
